import Vue from 'vue';
import Router from 'vue-router';
/* import Login from '@/components/Login';
import CommonPage from '@/components/CommonPage';
import CommonPostDetail from '@/components/CommonPostDetail';
import DiscussionAddForm from '@/components/DiscussionAddForm';
import AttachmentAddForm from '@/components/AttachmentAddForm';
import AddEditMenu from '@/components/AddEditMenu';
import EventAddForm from '@/components/EventAddForm';
import UserList from '@/components/UserList';
import ListUsers from '@/components/UserManagement/ListUsers';
import ListQRCodeScan from '@/components/QRCode/ListQRCodeScan';
import ViewQRCodeDetails from '@/components/QRCode/ViewQRCodeDetails';
import AddUser from '@/components/UserManagement/AddUser';
import AddCalendarKey from '@/components/AddCalendarKey';
import ListCalendarKey from '@/components/ListCalendarKey';
import GridQRCodeImages from '@/components/QRCode/GridQRCodeImages';
import GenerateQRCode from '@/components/QRCode/GenerateQRCode'; */

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      // component: Login
      component: () => import('../components/Login.vue')
    },
    {
      path: '/user/list',
      name: 'ListUsers',
      // component: ListUsers
      component: () => import('../components/UserManagement/ListUsers.vue')
    },
    {
      path: '/list/qrcodescan',
      name: 'ListQRCodeScan',
      // component: ListQRCodeScan
      component: () => import('../components/QRCode/ListQRCodeScan.vue')
    },
    {
      path: '/view/qrcodedetails/:id',
      name: 'ViewQRCodeDetails',
      // component: ViewQRCodeDetails
      component: () => import('../components/QRCode/ViewQRCodeDetails.vue')
    },
    {
      path: '/:type',
      name: 'CommonPage',
      // component: CommonPage
      component: () => import('../components/CommonPage.vue')
    },
    {
      path: '/:type/view',
      name: 'CommonPostDetail',
      // component: CommonPostDetail
      component: () => import('../components/CommonPostDetail.vue')
    },
    {
      path: '/:type/add_post',
      name: 'DiscussionAddForm',
      // component: DiscussionAddForm
      component: () => import('../components/DiscussionAddForm.vue')
    },
    {
      path: '/:type/edit_post/:id',
      name: 'DiscussionEditForm',
      // component: DiscussionAddForm
      component: () => import('../components/DiscussionAddForm.vue')
    },
    {
      path: '/:type/add_document',
      name: 'AttachmentAddForm',
      // component: AttachmentAddForm
      component: () => import('../components/AttachmentAddForm.vue')
    },
    {
      path: '/:type/edit_document/:id',
      name: 'AttachmentEditForm',
      // component: AttachmentAddForm
      component: () => import('../components/AttachmentAddForm.vue')
    },
    {
      path: '/:type/add_date',
      name: 'EventAddForm',
      // component: EventAddForm
      component: () => import('../components/EventAddForm.vue')
    },
    {
      path: '/:type/edit_date/:id',
      name: 'EventEditForm',
      // component: EventAddForm
      component: () => import('../components/EventAddForm.vue')
    },
    {
      path: '/menu/add-edit-menu',
      name: 'AddEditMenu',
      // component: AddEditMenu
      component: () => import('../components/AddEditMenu.vue')
    },
    {
      path: '/user/list',
      name: 'UserList',
      // component: UserList
      component: () => import('../components/UserList.vue')
    },
    {
      path: '/user/add',
      name: 'AddUser',
      // component: AddUser
      component: () => import('../components/UserManagement/AddUser.vue')
    },
    {
      path: '/updateuser/:id',
      name: 'UpdateUser',
      // component: AddUser
      component: () => import('../components/UserManagement/AddUser.vue')
    },
    {
      path: '/key/list',
      name: 'ListCalendarKey',
      // component: ListCalendarKey
      component: () => import('../components/ListCalendarKey.vue')
    },
    {
      path: '/key/add',
      name: 'AddCalendarKey',
      // component: AddCalendarKey
      component: () => import('../components/AddCalendarKey.vue')
    },
    {
      path: '/key/edit/:id',
      name: 'EditCalendarKey',
      // component: AddCalendarKey
      component: () => import('../components/AddCalendarKey.vue')
    },
    {
      path: '/qrcode/grid/:session',
      name: 'GridQRCodeImages',
      // component: GridQRCodeImages
      component: () => import('../components/QRCode/GridQRCodeImages.vue')
    },
    {
      path: '/qr-code/generate',
      name: 'GenerateQRCode',
      // component: GenerateQRCode
      component: () => import('../components/QRCode/GenerateQRCode.vue')
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js